
    <!--
 * 竖版-组队邀请
 * @LastEditTime: Tue Dec 17 2024 15:43:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_XTM149"  :class="[hasInviteCode ? 'last-order' : '',`normal main-color`,`u_c_XTM149`]" ><div id="u_c_AGGI50"  :class="[`${ compData.title ? 'text' : '' }`,`normal `,`u_c_AGGI50`]" ><div id="u_c_8WE251"  v-html="compData.title || langData.inviteTitle" :class="[`normal`,`u_c_8WE251`]" ></div></div><div id="u_c_3UO842"  :class="[`${ compData.title ? 'text' : '' }`,`normal main-color`,`u_c_3UO842`]" ><div id="u_c_5KUF43"  v-html="compData.subTitle || langData.inviteSubTitle" :class="[`normal`,`u_c_5KUF43`]" ></div></div><div id="u_c_C8DE49"  v-if="pageData.curTeamSize" :class="[`normal team-text`,`u_c_C8DE49`]" ><div id="u_c_HBHH50"  v-html="langData.myTeamNum.replace('${num}', `<span class='highlight'>${ pageData.curTeamSize } </span>`)" :class="[`normal`,`u_c_HBHH50`]" ></div><div id="u_c_TYCA55"  v-if="pageData.isCaptain" :class="[`normal`,`u_c_TYCA55`]" @click="u_c_TYCA55_event_023Y45($event)">{{compData.memberInfo.length == 1 ? langData.breakTeam : langData.breakDeny}}</div><div id="u_c_6TAH29"  v-if="!pageData.isCaptain" :class="[`normal`,`u_c_6TAH29`]" @click="u_c_6TAH29_event_L5YG46($event)">{{langData.exitTeam}}</div></div><div id="u_c_BR5S58"  :class="[`normal`,`u_c_BR5S58`]" ><div id="u_c_A3VL68"  v-for="(member, memberIndex) in compData.memberInfo" :key="memberIndex" :class="[`normal`,`u_c_A3VL68`]" ><div id="u_c_WO2J60"  v-if="member.name" :class="[`normal`,`u_c_WO2J60`]" @click="u_c_WO2J60_event_38UJ43($event)"><div id="u_c_ODFF62"  :class="[memberIndex == 0 ? 'leader' : 'member',`normal`,`u_c_ODFF62`]" ></div><div id="u_c_RW8L125"  v-if="memberIndex == 0" :class="[`normal`,`u_c_RW8L125`]" ></div><div id="u_c_E7KV69"  :class="[`normal team-text`,`u_c_E7KV69`]" >{{member.name}}</div></div><div id="u_c_3UDM120"  v-if="!member.name && memberIndex < compData.teamSize" :class="[`normal`,`u_c_3UDM120`]" ><div id="u_c_E5V0121"  :class="[`normal`,`u_c_E5V0121`]" ></div></div></div></div><a id="u_c_8IHY64" href="javascript:;" v-if="pageData.curTeamSize > 0" :class="[`normal  big-btn`,`u_c_8IHY64`]" @click="u_c_8IHY64_event_NP9I65($event)">{{pageData.teamSize == pageData.curTeamSize ? langData.teamNumFull : langData.inviteJoinTeam}}</a><a id="u_c_4D1R78" href="javascript:;" v-if="pageData.curTeamSize == 0" :class="[`normal big-btn`,`u_c_4D1R78`]" @click="u_c_4D1R78_event_NP9I65($event)">{{langData.createTeam}}</a><div id="u_c_9HV067"  v-if="pageData.isEdit || pageData.curTeamSize == 0" :class="[`normal`,`u_c_9HV067`]" @click="u_c_9HV067_event_5KBF86($event)">{{langData.joinOtherTeam}}</div><div id="u_c_YH0938"  v-if="pageData.isEdit ? false : pageData.curTeamSize > 1" :class="[`normal`,`u_c_YH0938`]" @click="u_c_YH0938_event_5KBF86($event)">{{langData.checkTeamInfo}}</div><h1 id="u_c_UUWG113"  :class="[`normal`,`u_c_UUWG113`]" ><div id="u_c_2DUT114"  v-html="compData.awardTitle || langData.mainTitle" :style="`text-shadow:0 0 10px #1b1b1b`" :class="[`normal`,`u_c_2DUT114`]" ></div><div id="u_c_7N6F115"  v-html="compData.awardTitle || langData.mainTitle" :style="`background-image:linear-gradient(to bottom, ${ pageData.mainTitleColorUp },${ pageData.mainTitleColorUp }, ${ pageData.mainTitleColorDown },${ pageData.mainTitleColorDown })`" :class="[`normal`,`u_c_7N6F115`]" ></div></h1><div id="u_c_N6OV40"  :class="[`normal team-text`,`u_c_N6OV40`]" ><span id="u_c_K9WL41"  :class="[`normal txt`,`u_c_K9WL41`]" @click="u_c_K9WL41_event_Y90J29($event)">{{`[${ langData.refresh }]`}}</span><span id="u_c_M5NQ43"  :class="[`normal txt`,`u_c_M5NQ43`]" @click="u_c_M5NQ43_event_Y90J29($event)">{{`[${ langData.myPackage }]`}}</span></div><div id="u_c_RPH3134"  :class="[`normal`,`u_c_RPH3134`]" ><div id="u_c_KE7J74"  v-for="(groupItem, groupIndex) in compData.awardInfo" :key="groupIndex" :class="[`normal`,`u_c_KE7J74`]" ><div id="u_c_V55685"  :class="[`normal team-text`,`u_c_V55685`]" ><div id="u_c_OCEA24"  v-html="langData.joinSuccss.replace('${num}', `<span 
class='highlight'>${ groupItem.num }</span> `)" :class="[`normal`,`u_c_OCEA24`]" ></div></div><div id="u_c_7WQ875"  :class="[`normal award-row`,`u_c_7WQ875`]" ><div id="u_c_8HI276"  :class="[`normal`,`u_c_8HI276`]" ><div id="u_c_P8O681"  v-for="(awardItem, awardIndex) in groupItem.pic" :key="awardIndex" :class="[`normal award-bg`,`u_c_P8O681`]" @click="u_c_P8O681_event_14TT19($event,groupItem)"><div id="u_c_1BZ782"  :style="`background-image:url(${ awardItem })`" :class="[`normal`,`u_c_1BZ782`]" ></div></div></div><div id="u_c_TI6J83"  :class="[groupItem.state == 2 ? 'has' : '',`normal get-btn`,`u_c_TI6J83`]" @click="u_c_TI6J83_event_5ZYN24($event,groupItem.state,groupItem.key,groupIndex)">{{groupItem.state == 0 ? langData.noFinish : groupItem.state == 1 ? langData.getBtn : langData.hasBtn}}</div></div></div><div id="u_c_746H44"  v-if="compData.showLeaderAward && compData.leaderAwardList.length" :class="[`normal`,`u_c_746H44`]" ><div id="u_c_IM8745"  :class="[`normal team-text`,`u_c_IM8745`]" >{{langData.teamFilledAward}}</div><div id="u_c_Z39147"  :class="[`normal award-row`,`u_c_Z39147`]" ><div id="u_c_DUIH48"  :class="[`normal`,`u_c_DUIH48`]" ><div id="u_c_6NEU49"  v-for="(awardItem, awardIndex) in compData.leaderAwardList[0].pic" :key="awardIndex" :class="[`normal award-bg`,`u_c_6NEU49`]" @click="u_c_6NEU49_event_UHIC20($event)"><div id="u_c_5QY050"  :style="`background-image:url(${ awardItem })`" :class="[`normal`,`u_c_5QY050`]" ></div></div></div><div id="u_c_59CO51"  :class="[compData.leaderAwardList[0]?.state == 2 ? 'has' : '',`normal get-btn`,`u_c_59CO51`]" @click="u_c_59CO51_event_5ZYN24($event,compData.leaderAwardList[0]?.state)">{{compData.leaderAwardList[0]?.state == 0 ? langData.noFinish : compData.leaderAwardList[0]?.state == 1 ? langData.getBtn : langData.hasBtn}}</div></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":`组队邀请`,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":`活动期间一起组队做任务兑大奖！ 
登陆、分享、充值都可以获得对应奖励`,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":3,"pic":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png"],"awardDetail":"奖励1 X 2; 奖励2 X 2","state":0},{"num":4,"pic":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png"],"awardDetail":"1234","state":0}],"awardTitle":`组队奖励 `,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"],"awardDetail":"","state":0}],"showLeaderAward":true,"teamSize":5},"zh-CN":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"钻石*200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"小型资源补给箱*10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"强化选择补给箱*5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"加速60分钟*5","state":0}],"showLeaderAward":true,"teamSize":5},"zh-TW":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"鑽石 *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"小型資源補給箱 *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"強化選擇補給箱 *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"加速60分鐘 *5","state":0}],"showLeaderAward":true,"teamSize":5},"en-US":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Diamond *200","state":0},{"num":3,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Lesser Resource Box *10","state":0},{"num":5,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Enhance Choice Box *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":" 60-min Speedup *5","state":0}],"showLeaderAward":true,"teamSize":5},"ja-JP":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"ダイヤ *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"小型資源補給 *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"選択型強化補給 *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"ブースト（60分間） *5","state":0}],"showLeaderAward":true,"teamSize":5},"ko-KR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"다이아 *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"소형 자원 보급 상자 *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"강화 선택 보급상자 *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"60분 가속 *5","state":0}],"showLeaderAward":true,"teamSize":5},"th-TH":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"เพชร *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"หีบทรัพยากรไซส์มินิ *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"หีบเลือกตีบวก *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"เร่งสปีด60นาที *5","state":0}],"showLeaderAward":true,"teamSize":5},"vi-VN":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Kim Cương *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Rương Tài Nguyên Nhỏ *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Rương Chọn Cường Hoá *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"Tăng tốc 60 phút *5","state":0}],"showLeaderAward":true,"teamSize":5},"de-DE":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Diamant *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Kleine Ressource Kiste *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Verbessern Auswahlkiste *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"60 Min Beschleunigen *5","state":0}],"showLeaderAward":true,"teamSize":5},"fr-FR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Diamant *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Petite boîte ressources *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Boîte de renforcement au choix *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"Accélération 60-min *5","state":0}],"showLeaderAward":true,"teamSize":5},"ru-RU":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Алмаз *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Малый Ящик с Ресурсами *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Ящик с Улучшениями на Выбор *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"Ускорение (60 мин.) *5","state":0}],"showLeaderAward":true,"teamSize":5},"es-ES":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Diamante *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Caja de Recursos Inferior *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Mejora la Caja de Elección *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"Aceleración de 60 min *5","state":0}],"showLeaderAward":true,"teamSize":5},"pt-PT":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Diamante *200 ","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Caixa Menor de Recursos *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Caixa da Escolha de Melhorias *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"Aceleração de 60 minutos *5","state":0}],"showLeaderAward":true,"teamSize":5},"it-IT":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Diamante *200 ","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Scatola Risorse Minore *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Scatola Scelta Migliora *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"Velocizz. 60-min *5","state":0}],"showLeaderAward":true,"teamSize":5},"tr-TR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Elmas *200","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Küçük Kaynak Kutusu *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":" Büyütme Seçimi Kutusu *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"60-dk Hızlandırma *5","state":0}],"showLeaderAward":true,"teamSize":5},"pl-PL":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Diament *200 ","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Mniejsze Pudełko z Zasobami *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Pudło Wyboru Wzmocnienia *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"60-min. Przyśpieszenie *5","state":0}],"showLeaderAward":true,"teamSize":5},"id-ID":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"Diamond *200 ","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"Small Resource Supply Box *10","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"Enhance Choice Supply Box *5","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"Speed up 60 menit *5","state":0}],"showLeaderAward":true,"teamSize":5},"ar-SA":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","giftName":"","title":``,"inviteTextArray":[{ title: '文案A', content: '接受我的邀请，现在立刻马上'},{ title: '文案B', content: '接受他的邀请，现在立刻马上'},{ title: '文案C', content: '接受她的邀请，现在立刻马上'},{ title: '文案D', content: '接受它的邀请，现在立刻马上'}],"activeTabIndex":`0`,"subTitle":``,"showLetter":true,"memberInfo":[{leader:true, name: 'captain'},{name:'member'},{},{},{}],"awardInfo":[{"num":"2","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png"],"awardDetail":"200* الماس ","state":0},{"num":"3","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634927448805741.png"],"awardDetail":"10* صندوق الموارد الصغير","state":0},{"num":"5","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"],"awardDetail":"5* اختيار صندوق الإمدادات","state":0}],"awardTitle":``,"leaderAwardList":[{"num":2,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634925558898149.png"],"awardDetail":"5* تسريع 60 دقيقة","state":0}],"showLeaderAward":true,"teamSize":5}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '组队邀请';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})
const getAward = inject("getAward", (type, key) => {})
const initActivity = inject("initActivity", () => {})
const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global"
const canClick = ref(true)
const canClickInvite = ref(true)
const hasInviteCode = utils.getUrlParams("inviteCode").length > 0;
const canClickRefresh = inject("canClickRefresh", true);
const openInvitePanel = inject("openInvitePanel", () => {})
const firstInit = ref(true);
watch(
  () => listData,
  (value) => {
    if (value && value.teamAward) {
      let confList = _.cloneDeep(compData.awardInfo);
      compData.awardInfo = [];
      value.teamAward.forEach((item, index) => {
        if (confList[index]) {
          let picList = confList[index].pic;
          let awardDetail = confList[index].awardDetail;
          if (+item.ticket > 0 && firstInit.value) {
            picList.unshift(pageData.lotteryIcon);
            awardDetail = `${langData.lotteryCoupon} *${item.ticket}、 ${awardDetail}`;
          }
          compData.awardInfo.push({
            num: item.team_size,
            pic: picList,
            awardDetail,
            state: item.status,
            key: item.key,
          });
        }
      });
      giftInfo.teamAward = compData.awardInfo;
    }
    if (value && value.captainAward) {
      let confList = _.cloneDeep(compData.leaderAwardList);
      compData.leaderAwardList = [];
      value.captainAward.forEach((item, index) => {
        if (confList[index]) {
          let picList = confList[index].pic;
          let awardDetail = confList[index].awardDetail;
          if (+item.ticket > 0 && firstInit.value) {
            picList.unshift(pageData.lotteryIcon);
            awardDetail = `${langData.lotteryCoupon} *${item.ticket}、 ${awardDetail}`;
          }
          compData.leaderAwardList.push({
            num: item.team_size,
            pic: picList,
            awardDetail,
            state: item.status,
            key: item.key,
          });
        }
      });
      giftInfo.captainAward = compData.leaderAwardList;
    }
    if (value && value.teamList) {
      let confList = _.cloneDeep(compData.memberInfo);
      compData.memberInfo = [];
      value.teamList.forEach((item, index) => {
        compData.memberInfo.push({
          name: item.roleName || item.role_name,
        });
      });
    }
    firstInit.value = false;
  }, {
    deep: true,
  }
);;
      // 队长：解散的click事件
      const u_c_TYCA55_event_023Y45= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `解散队伍`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
if (compData.memberInfo.length > 1) {
  showTips(langData.breakDenyTips)
  return;
}
pageData.breakTeamPopupState=true;} catch (error) {console.log(error)}
      };
      // 队员：退出队伍的click事件
      const u_c_6TAH29_event_L5YG46= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `退出队伍`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
if (!pageData.canExit) {
  showTips(langData.teamExitDenyTips)
  return;
}
pageData.exitTeamPopupState=true;} catch (error) {console.log(error)}
      };
      // 已邀请的click事件
      const u_c_WO2J60_event_38UJ43= async (e)=>{
        try {// const teamInfoArray = [
//   `<div class="popup-title popup-title-color">${langData.myTeam}<div/><br/>`,
// ];
// compData.memberInfo.forEach((item, index) => {
//   if (index == 0) {
//     teamInfoArray.push(
//       `<div class="txt-size">${item.name}(${langData.captain})</div>`
//     );
//   } else {
//     teamInfoArray.push(`<div class="txt-size">${item.name}</div>`);
//   }
// });
// showTips(teamInfoArray.join(""));
pageData.teamInfoPopupState=true} catch (error) {console.log(error)}
      };
      // 发起邀请的click事件
      const u_c_8IHY64_event_NP9I65= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
// 满员滚动至组队任务teamTask板块
if (pageData.teamSize == pageData.curTeamSize) {
  const teamTask = document.getElementsByClassName("teamTaskSection");
  if (teamTask) {
    teamTask[0].scrollIntoView({
      behavior: "smooth"
    });
  }
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: `小队满员滚动至组队任务`,
    gameId: pageData.gameId,
    aid: pageData.pageId,
  });
  return;
}
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `发起邀请`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
await openInvitePanel()} catch (error) {console.log(error)}
      };
      // 创建队伍的click事件
      const u_c_4D1R78_event_NP9I65= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `创建队伍`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
const link = {
  gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=createTeam`,
  global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=createTeam`,
  omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=createTeam`,
};
let res = await request.getJSON(link[curPlatform]);
if (res?.result != 1) {
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
  return;
}
await initActivity();} catch (error) {console.log(error)}
      };
      // 加入其他队伍的click事件
      const u_c_9HV067_event_5KBF86= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `加入其他队伍`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
pageData.inviteBindPopupState=true} catch (error) {console.log(error)}
      };
      // 查看队伍信息的click事件
      const u_c_YH0938_event_5KBF86= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `查看队伍信息`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
pageData.teamInfoPopupState=true} catch (error) {console.log(error)}
      };
      // 刷新的click事件
      const u_c_K9WL41_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 我的背包的click事件
      const u_c_M5NQ43_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "组队邀请-背包",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
pageData.curBagType = 'team_award'
pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 奖励项的click事件
      const u_c_P8O681_event_14TT19= async (e,data)=>{
        try {showTips(data.awardDetail);} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_TI6J83_event_5ZYN24= async (e,state,key,index)=>{
        try {if (state != 1) {
  return;
}
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "组队奖励-领取按钮",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
const res = await getAward('team_award', key)
if (res.result == 1) {
  compData.awardInfo[index].state = 2;
}} catch (error) {console.log(error)}
      };
      // 奖励项的click事件
      const u_c_6NEU49_event_UHIC20= async (e)=>{
        try {showTips(compData.leaderAwardList[0].awardDetail);} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_59CO51_event_5ZYN24= async (e,state)=>{
        try {if (state != 1) {
  return;
}
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "组队队长额外奖励-领取按钮",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
const res = await getAward('captain_award', compData.leaderAwardList[0].key)
if (res.result == 1) {
  compData.leaderAwardList[0].state = 2
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_8WE251.normal{
position:relative;

}
}.default{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.default{
.u_c_5KUF43.normal{
position:relative;

}
}.default{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.default{
.u_c_HBHH50.normal{
position:relative;

}
}.default{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.default{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.default{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.default{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.default{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.default{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.default{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.default{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.default{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.default{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.default{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.default{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.default{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.default{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.default{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.default{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.default{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.default{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.default{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.default{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.default{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.default{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.default{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.default{
.u_c_OCEA24.normal{
position:relative;

}
}.default{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.default{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.default{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.default{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.default{
.u_c_TI6J83.normal{
position:relative;

}
}.default{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.default{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.default{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.default{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.default{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.default{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.default{
.u_c_59CO51.normal{
position:relative;

}
}.zh-CN{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_8WE251.normal{
position:relative;

}
}.zh-CN{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.zh-CN{
.u_c_5KUF43.normal{
position:relative;

}
}.zh-CN{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.zh-CN{
.u_c_HBHH50.normal{
position:relative;

}
}.zh-CN{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.zh-CN{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.zh-CN{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.zh-CN{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.zh-CN{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.zh-CN{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.zh-CN{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.zh-CN{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.zh-CN{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.zh-CN{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.zh-CN{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.zh-CN{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.zh-CN{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.zh-CN{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.zh-CN{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.zh-CN{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.zh-CN{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.zh-CN{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.zh-CN{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.zh-CN{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-CN{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.zh-CN{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.zh-CN{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.zh-CN{
.u_c_OCEA24.normal{
position:relative;

}
}.zh-CN{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.zh-CN{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.zh-CN{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.zh-CN{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.zh-CN{
.u_c_TI6J83.normal{
position:relative;

}
}.zh-CN{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.zh-CN{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.zh-CN{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.zh-CN{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.zh-CN{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.zh-CN{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.zh-CN{
.u_c_59CO51.normal{
position:relative;

}
}.zh-TW{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_8WE251.normal{
position:relative;

}
}.zh-TW{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.zh-TW{
.u_c_5KUF43.normal{
position:relative;

}
}.zh-TW{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.zh-TW{
.u_c_HBHH50.normal{
position:relative;

}
}.zh-TW{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.zh-TW{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.zh-TW{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.zh-TW{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.zh-TW{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.zh-TW{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.zh-TW{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.zh-TW{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.zh-TW{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.zh-TW{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.zh-TW{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.zh-TW{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.zh-TW{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.zh-TW{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.zh-TW{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.zh-TW{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.zh-TW{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.zh-TW{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.zh-TW{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-TW{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.zh-TW{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.zh-TW{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.zh-TW{
.u_c_OCEA24.normal{
position:relative;

}
}.zh-TW{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.zh-TW{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.zh-TW{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.zh-TW{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.zh-TW{
.u_c_TI6J83.normal{
position:relative;

}
}.zh-TW{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.zh-TW{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.zh-TW{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.zh-TW{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.zh-TW{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.zh-TW{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.zh-TW{
.u_c_59CO51.normal{
position:relative;

}
}.en-US{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_8WE251.normal{
position:relative;

}
}.en-US{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.en-US{
.u_c_5KUF43.normal{
position:relative;

}
}.en-US{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.en-US{
.u_c_HBHH50.normal{
position:relative;

}
}.en-US{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.en-US{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.en-US{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.en-US{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.en-US{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.en-US{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.en-US{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.en-US{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.en-US{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.en-US{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.en-US{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.en-US{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.en-US{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.en-US{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.en-US{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.en-US{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.en-US{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.en-US{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.en-US{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.en-US{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.en-US{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.en-US{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.en-US{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.en-US{
.u_c_OCEA24.normal{
position:relative;

}
}.en-US{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.en-US{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.en-US{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.en-US{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.en-US{
.u_c_TI6J83.normal{
position:relative;

}
}.en-US{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.en-US{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.en-US{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.en-US{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.en-US{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.en-US{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.en-US{
.u_c_59CO51.normal{
position:relative;

}
}.ja-JP{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_8WE251.normal{
position:relative;

}
}.ja-JP{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.ja-JP{
.u_c_5KUF43.normal{
position:relative;

}
}.ja-JP{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.ja-JP{
.u_c_HBHH50.normal{
position:relative;

}
}.ja-JP{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.ja-JP{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.ja-JP{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.ja-JP{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.ja-JP{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.ja-JP{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.ja-JP{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.ja-JP{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.ja-JP{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.ja-JP{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.ja-JP{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.ja-JP{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.ja-JP{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.ja-JP{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.ja-JP{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.ja-JP{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ja-JP{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.ja-JP{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.ja-JP{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ja-JP{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ja-JP{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.ja-JP{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.ja-JP{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.ja-JP{
.u_c_OCEA24.normal{
position:relative;

}
}.ja-JP{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ja-JP{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ja-JP{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.ja-JP{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.ja-JP{
.u_c_TI6J83.normal{
position:relative;

}
}.ja-JP{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.ja-JP{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.ja-JP{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ja-JP{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ja-JP{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.ja-JP{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.ja-JP{
.u_c_59CO51.normal{
position:relative;

}
}.ko-KR{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_8WE251.normal{
position:relative;

}
}.ko-KR{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.ko-KR{
.u_c_5KUF43.normal{
position:relative;

}
}.ko-KR{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.ko-KR{
.u_c_HBHH50.normal{
position:relative;

}
}.ko-KR{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.ko-KR{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.ko-KR{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.ko-KR{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.ko-KR{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.ko-KR{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.ko-KR{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.ko-KR{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.ko-KR{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.ko-KR{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.ko-KR{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.ko-KR{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.ko-KR{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.ko-KR{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.ko-KR{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.ko-KR{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ko-KR{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.ko-KR{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.ko-KR{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ko-KR{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ko-KR{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.ko-KR{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.ko-KR{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.ko-KR{
.u_c_OCEA24.normal{
position:relative;

}
}.ko-KR{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ko-KR{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ko-KR{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.ko-KR{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.ko-KR{
.u_c_TI6J83.normal{
position:relative;

}
}.ko-KR{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.ko-KR{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.ko-KR{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ko-KR{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ko-KR{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.ko-KR{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.ko-KR{
.u_c_59CO51.normal{
position:relative;

}
}.th-TH{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_8WE251.normal{
position:relative;

}
}.th-TH{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.th-TH{
.u_c_5KUF43.normal{
position:relative;

}
}.th-TH{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.th-TH{
.u_c_HBHH50.normal{
position:relative;

}
}.th-TH{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.th-TH{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.th-TH{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.th-TH{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.th-TH{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.th-TH{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.th-TH{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.th-TH{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.th-TH{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.th-TH{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.th-TH{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.th-TH{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.th-TH{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.th-TH{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.th-TH{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.th-TH{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.th-TH{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.th-TH{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.th-TH{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.th-TH{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.th-TH{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.th-TH{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.th-TH{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.th-TH{
.u_c_OCEA24.normal{
position:relative;

}
}.th-TH{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.th-TH{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.th-TH{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.th-TH{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.th-TH{
.u_c_TI6J83.normal{
position:relative;

}
}.th-TH{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.th-TH{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.th-TH{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.th-TH{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.th-TH{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.th-TH{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.th-TH{
.u_c_59CO51.normal{
position:relative;

}
}.vi-VN{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_8WE251.normal{
position:relative;

}
}.vi-VN{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.vi-VN{
.u_c_5KUF43.normal{
position:relative;

}
}.vi-VN{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.vi-VN{
.u_c_HBHH50.normal{
position:relative;

}
}.vi-VN{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.vi-VN{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.vi-VN{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.vi-VN{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.vi-VN{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.vi-VN{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.vi-VN{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.vi-VN{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.vi-VN{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.vi-VN{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.vi-VN{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.vi-VN{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.vi-VN{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.vi-VN{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.vi-VN{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.vi-VN{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.vi-VN{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.vi-VN{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.vi-VN{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.vi-VN{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.vi-VN{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.vi-VN{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.vi-VN{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.vi-VN{
.u_c_OCEA24.normal{
position:relative;

}
}.vi-VN{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.vi-VN{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.vi-VN{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.vi-VN{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.vi-VN{
.u_c_TI6J83.normal{
position:relative;

}
}.vi-VN{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.vi-VN{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.vi-VN{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.vi-VN{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.vi-VN{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.vi-VN{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.vi-VN{
.u_c_59CO51.normal{
position:relative;

}
}.de-DE{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_8WE251.normal{
position:relative;

}
}.de-DE{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.de-DE{
.u_c_5KUF43.normal{
position:relative;

}
}.de-DE{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.de-DE{
.u_c_HBHH50.normal{
position:relative;

}
}.de-DE{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.de-DE{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.de-DE{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.de-DE{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.de-DE{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.de-DE{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.de-DE{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.de-DE{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.de-DE{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.de-DE{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.de-DE{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.de-DE{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.de-DE{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.de-DE{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.de-DE{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.de-DE{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.de-DE{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.de-DE{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.de-DE{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.de-DE{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.de-DE{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.de-DE{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.de-DE{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.de-DE{
.u_c_OCEA24.normal{
position:relative;

}
}.de-DE{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.de-DE{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.de-DE{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.de-DE{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.de-DE{
.u_c_TI6J83.normal{
position:relative;

}
}.de-DE{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.de-DE{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.de-DE{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.de-DE{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.de-DE{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.de-DE{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.de-DE{
.u_c_59CO51.normal{
position:relative;

}
}.fr-FR{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_8WE251.normal{
position:relative;

}
}.fr-FR{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.fr-FR{
.u_c_5KUF43.normal{
position:relative;

}
}.fr-FR{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.fr-FR{
.u_c_HBHH50.normal{
position:relative;

}
}.fr-FR{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.fr-FR{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.fr-FR{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.fr-FR{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.fr-FR{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.fr-FR{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.fr-FR{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.fr-FR{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.fr-FR{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.fr-FR{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.fr-FR{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.fr-FR{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.fr-FR{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.fr-FR{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.fr-FR{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.fr-FR{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.fr-FR{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.fr-FR{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.fr-FR{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.fr-FR{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.fr-FR{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.fr-FR{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.fr-FR{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.fr-FR{
.u_c_OCEA24.normal{
position:relative;

}
}.fr-FR{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.fr-FR{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.fr-FR{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.fr-FR{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.fr-FR{
.u_c_TI6J83.normal{
position:relative;

}
}.fr-FR{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.fr-FR{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.fr-FR{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.fr-FR{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.fr-FR{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.fr-FR{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.fr-FR{
.u_c_59CO51.normal{
position:relative;

}
}.ru-RU{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_8WE251.normal{
position:relative;

}
}.ru-RU{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.ru-RU{
.u_c_5KUF43.normal{
position:relative;

}
}.ru-RU{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.ru-RU{
.u_c_HBHH50.normal{
position:relative;

}
}.ru-RU{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.ru-RU{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.ru-RU{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.ru-RU{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.ru-RU{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.ru-RU{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.ru-RU{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.ru-RU{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.ru-RU{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.ru-RU{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.ru-RU{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.ru-RU{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.ru-RU{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.ru-RU{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.ru-RU{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.ru-RU{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ru-RU{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.ru-RU{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.ru-RU{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ru-RU{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ru-RU{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.ru-RU{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.ru-RU{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.ru-RU{
.u_c_OCEA24.normal{
position:relative;

}
}.ru-RU{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ru-RU{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ru-RU{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.ru-RU{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.ru-RU{
.u_c_TI6J83.normal{
position:relative;

}
}.ru-RU{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.ru-RU{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.ru-RU{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ru-RU{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ru-RU{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.ru-RU{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.ru-RU{
.u_c_59CO51.normal{
position:relative;

}
}.es-ES{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_8WE251.normal{
position:relative;

}
}.es-ES{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.es-ES{
.u_c_5KUF43.normal{
position:relative;

}
}.es-ES{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.es-ES{
.u_c_HBHH50.normal{
position:relative;

}
}.es-ES{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.es-ES{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.es-ES{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.es-ES{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.es-ES{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.es-ES{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.es-ES{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.es-ES{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.es-ES{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.es-ES{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.es-ES{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.es-ES{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.es-ES{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.es-ES{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.es-ES{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.es-ES{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.es-ES{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.es-ES{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.es-ES{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.es-ES{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.es-ES{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.es-ES{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.es-ES{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.es-ES{
.u_c_OCEA24.normal{
position:relative;

}
}.es-ES{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.es-ES{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.es-ES{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.es-ES{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.es-ES{
.u_c_TI6J83.normal{
position:relative;

}
}.es-ES{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.es-ES{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.es-ES{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.es-ES{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.es-ES{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.es-ES{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.es-ES{
.u_c_59CO51.normal{
position:relative;

}
}.pt-PT{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_8WE251.normal{
position:relative;

}
}.pt-PT{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.pt-PT{
.u_c_5KUF43.normal{
position:relative;

}
}.pt-PT{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.pt-PT{
.u_c_HBHH50.normal{
position:relative;

}
}.pt-PT{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.pt-PT{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.pt-PT{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.pt-PT{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.pt-PT{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.pt-PT{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.pt-PT{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.pt-PT{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.pt-PT{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.pt-PT{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.pt-PT{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.pt-PT{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.pt-PT{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.pt-PT{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.pt-PT{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.pt-PT{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.pt-PT{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.pt-PT{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.pt-PT{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.pt-PT{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pt-PT{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.pt-PT{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.pt-PT{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.pt-PT{
.u_c_OCEA24.normal{
position:relative;

}
}.pt-PT{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.pt-PT{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.pt-PT{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.pt-PT{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.pt-PT{
.u_c_TI6J83.normal{
position:relative;

}
}.pt-PT{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.pt-PT{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.pt-PT{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.pt-PT{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.pt-PT{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.pt-PT{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.pt-PT{
.u_c_59CO51.normal{
position:relative;

}
}.it-IT{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_8WE251.normal{
position:relative;

}
}.it-IT{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.it-IT{
.u_c_5KUF43.normal{
position:relative;

}
}.it-IT{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.it-IT{
.u_c_HBHH50.normal{
position:relative;

}
}.it-IT{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.it-IT{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.it-IT{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.it-IT{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.it-IT{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.it-IT{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.it-IT{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.it-IT{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.it-IT{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.it-IT{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.it-IT{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.it-IT{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.it-IT{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.it-IT{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.it-IT{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.it-IT{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.it-IT{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.it-IT{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.it-IT{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.it-IT{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.it-IT{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.it-IT{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.it-IT{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.it-IT{
.u_c_OCEA24.normal{
position:relative;

}
}.it-IT{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.it-IT{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.it-IT{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.it-IT{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.it-IT{
.u_c_TI6J83.normal{
position:relative;

}
}.it-IT{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.it-IT{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.it-IT{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.it-IT{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.it-IT{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.it-IT{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.it-IT{
.u_c_59CO51.normal{
position:relative;

}
}.tr-TR{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_8WE251.normal{
position:relative;

}
}.tr-TR{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.tr-TR{
.u_c_5KUF43.normal{
position:relative;

}
}.tr-TR{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.tr-TR{
.u_c_HBHH50.normal{
position:relative;

}
}.tr-TR{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.tr-TR{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.tr-TR{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.tr-TR{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.tr-TR{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.tr-TR{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.tr-TR{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.tr-TR{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.tr-TR{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.tr-TR{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.tr-TR{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.tr-TR{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.tr-TR{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.tr-TR{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.tr-TR{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.tr-TR{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.tr-TR{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.tr-TR{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.tr-TR{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.tr-TR{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.tr-TR{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.tr-TR{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.tr-TR{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.tr-TR{
.u_c_OCEA24.normal{
position:relative;

}
}.tr-TR{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.tr-TR{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.tr-TR{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.tr-TR{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.tr-TR{
.u_c_TI6J83.normal{
position:relative;

}
}.tr-TR{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.tr-TR{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.tr-TR{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.tr-TR{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.tr-TR{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.tr-TR{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.tr-TR{
.u_c_59CO51.normal{
position:relative;

}
}.pl-PL{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_8WE251.normal{
position:relative;

}
}.pl-PL{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.pl-PL{
.u_c_5KUF43.normal{
position:relative;

}
}.pl-PL{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.pl-PL{
.u_c_HBHH50.normal{
position:relative;

}
}.pl-PL{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.pl-PL{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.pl-PL{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.pl-PL{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.pl-PL{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.pl-PL{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.pl-PL{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.pl-PL{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.pl-PL{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.pl-PL{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.pl-PL{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.pl-PL{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.pl-PL{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.pl-PL{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.pl-PL{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.pl-PL{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.pl-PL{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.pl-PL{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.pl-PL{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.pl-PL{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pl-PL{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.pl-PL{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.pl-PL{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.pl-PL{
.u_c_OCEA24.normal{
position:relative;

}
}.pl-PL{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.pl-PL{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.pl-PL{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.pl-PL{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.pl-PL{
.u_c_TI6J83.normal{
position:relative;

}
}.pl-PL{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.pl-PL{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.pl-PL{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.pl-PL{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.pl-PL{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.pl-PL{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.pl-PL{
.u_c_59CO51.normal{
position:relative;

}
}.id-ID{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_8WE251.normal{
position:relative;

}
}.id-ID{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.id-ID{
.u_c_5KUF43.normal{
position:relative;

}
}.id-ID{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.id-ID{
.u_c_HBHH50.normal{
position:relative;

}
}.id-ID{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.id-ID{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.id-ID{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.id-ID{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.id-ID{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.id-ID{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.id-ID{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.id-ID{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.id-ID{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.id-ID{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.id-ID{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.id-ID{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.id-ID{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.id-ID{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.id-ID{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.id-ID{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.id-ID{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.id-ID{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.id-ID{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.id-ID{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.id-ID{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.id-ID{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.id-ID{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.id-ID{
.u_c_OCEA24.normal{
position:relative;

}
}.id-ID{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.id-ID{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.id-ID{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.id-ID{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.id-ID{
.u_c_TI6J83.normal{
position:relative;

}
}.id-ID{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.id-ID{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.id-ID{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.id-ID{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.id-ID{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.id-ID{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.id-ID{
.u_c_59CO51.normal{
position:relative;

}
}.ar-SA{
.u_c_XTM149.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006094-74.png);
border-radius:0.27rem;

}

.u_c_XTM149.normal .team-text{
font-size:0.27rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_XTM149.normal .big-btn{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
background-size:100% 100%;
width:8.12rem;
height:1.60rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006028-90.png);
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_AGGI50.normal{
position:relative;
width:6.04rem;
height:1.24rem;
margin:auto;
margin-top:-0.68rem;
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005719-36.png);
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_8WE251.normal{
position:relative;

}
}.ar-SA{
.u_c_3UO842.normal{
position:relative;
width:6.67rem;
height:auto;
margin:auto;
margin-top:0.33rem;
font-size:0.27rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.3;

}

.u_c_3UO842.normal.text{
height:auto;

}
}.ar-SA{
.u_c_5KUF43.normal{
position:relative;

}
}.ar-SA{
.u_c_C8DE49.normal{
position:relative;
display:flex;
width:8.31rem;
justify-content:space-between;
margin:0 auto;
margin-top:0.59rem;

}
}.ar-SA{
.u_c_HBHH50.normal{
position:relative;

}
}.ar-SA{
.u_c_TYCA55.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.ar-SA{
.u_c_6TAH29.normal{
position:relative;
text-decoration:underline;
display:flex;
align-items:center;
cursor:pointer;

}
}.ar-SA{
.u_c_BR5S58.normal{
position:relative;
display:flex;
justify-content:space-evenly;
align-items:center;
margin-top:0.29rem;

}
}.ar-SA{
.u_c_A3VL68.normal{
position:relative;
background:no-repeat center;
background-size:100% 100%;
cursor:pointer;
background-color:#253d55;
border-radius:0.20rem;

}
}.ar-SA{
.u_c_WO2J60.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
background-color:#1966a9;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;
border-radius:0.20rem;

}

.u_c_WO2J60.normal .leader{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png);
background-size:100% 100%;

}

.u_c_WO2J60.normal .member{
position:relative;
width:1.09rem;
height:1.09rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005801-35.png);
background-size:100% 100%;

}
}.ar-SA{
.u_c_ODFF62.normal{
position:relative;
background-size:100% 100%;

}
}.ar-SA{
.u_c_RW8L125.normal{
position:absolute;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png);
top:0;
right:0;
width:0.64rem;
height:0.67rem;

}
}.ar-SA{
.u_c_E7KV69.normal{
position:relative;
margin-top:0.27rem;
text-align:center;
overflow:hidden!important;
text-overflow:ellipsis!important;
white-space:nowrap!important;
width:1.19rem;

}
}.ar-SA{
.u_c_3UDM120.normal{
position:relative;
width:1.37rem;
height:2.32rem;
background:no-repeat center;
display:flex;
align-items:center;
box-sizing:border-box;
padding:0.13rem 0.07rem 0;
flex-direction:column;
background-size:100% 100%;

}
}.ar-SA{
.u_c_E5V0121.normal{
position:relative;
width:1.03rem;
height:1.04rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005888-82.png);
background-size:100% 100%;

}
}.ar-SA{
.u_c_8IHY64.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_8IHY64.normal.has{
filter:grayscale(1);

}
}.ar-SA{
.u_c_4D1R78.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.33rem;
display:block;
overflow:hidden;

}

.u_c_4D1R78.normal.has{
filter:grayscale(1);

}
}.ar-SA{
.u_c_9HV067.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0;
cursor:pointer;

}
}.ar-SA{
.u_c_YH0938.normal{
position:relative;
text-decoration:underline;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
top:0.08rem;
cursor:pointer;

}
}.ar-SA{
.u_c_UUWG113.normal{
position:relative;
margin-top:0.80rem;
width:100%;
height:fit-content;
font-size:0.60rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.ar-SA{
.u_c_2DUT114.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ar-SA{
.u_c_7N6F115.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.ar-SA{
.u_c_N6OV40.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;
margin-top:0.13rem;

}
}.ar-SA{
.u_c_K9WL41.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ar-SA{
.u_c_M5NQ43.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ar-SA{
.u_c_RPH3134.normal{
position:relative;
width:100%;
height:9.44rem;
margin-top:0.17rem;
overflow-y:auto;

}

.u_c_RPH3134.normal .get-btn{
position:relative;
width:2.67rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
font-weight:normal;
cursor:pointer;

}

.u_c_RPH3134.normal .has{
filter:grayscale(1);

}

.u_c_RPH3134.normal .award-row{
background-color:#1e3a52;
 border-radius:0.13rem;

}

.u_c_RPH3134.normal .award-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726731193831-49.png);

}
}.ar-SA{
.u_c_KE7J74.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.ar-SA{
.u_c_V55685.normal{
position:relative;
left:0.39rem;
margin-bottom:0.11rem;

}
}.ar-SA{
.u_c_OCEA24.normal{
position:relative;

}
}.ar-SA{
.u_c_7WQ875.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ar-SA{
.u_c_8HI276.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ar-SA{
.u_c_P8O681.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.ar-SA{
.u_c_1BZ782.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.ar-SA{
.u_c_TI6J83.normal{
position:relative;

}
}.ar-SA{
.u_c_746H44.normal{
position:relative;
margin-bottom:0.27rem;
overflow:hidden;

}
}.ar-SA{
.u_c_IM8745.normal{
position:relative;
left:0.41rem;
margin-bottom:0.11rem;

}
}.ar-SA{
.u_c_Z39147.normal{
position:relative;
height:1.57rem;
width:8.41rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ar-SA{
.u_c_DUIH48.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ar-SA{
.u_c_6NEU49.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.27rem;
flex-shrink:0;

}
}.ar-SA{
.u_c_5QY050.normal{
position:relative;
width:0.81rem;
height:0.92rem;
background:no-repeat center;
background-size:contain;

}
}.ar-SA{
.u_c_59CO51.normal{
position:relative;

}
}
</style>
